module.exports = __webpack_public_path__ + "img/product_69.f2e3585.webp";